import $ from 'jquery'

export default (to, from, next) => {
  $('#js-bootstrap-offcanvas-nav').trigger('offcanvas.close')

  next()
}
